import React, { lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { routes } from "../constants/routes";
import AdminDashboard from "../pages/AdminDashboard";
import ProtectedRoute from "./ProtectedRoute";
import ConfirmOTP from "../pages/Auth/forgot-password/ConfirmOTP";
import CreateNewPassword from "../pages/Auth/forgot-password/CreateNewPassword";

const PatientList = lazy(() => import("../pages/PatientList"));
const ConsultantList = lazy(() => import("../pages/ConsultantList"));
const ConsultantDetails = lazy(() => import("../pages/ConsultantDetails"));
const ConsultationsList = lazy(() => import("../pages/ConsultationList"));
const MetricsDashboard = lazy(() => import("../pages/MetricsDashboard"));
const PlanList = lazy(() => import("../pages/PlanList"));
const CouponList = lazy(() => import("../pages/CouponList"));
const CountryList = lazy(() => import("../pages/CountryList"));
const PlanBuilder = lazy(() => import("../pages/PlanBuilder"));
const Subscriptions = lazy(() => import("../pages/Subscriptions"));
const SubscriptionDetails = lazy(() => import("../pages/SubscriptionDetails"));
const CustomFeatures = lazy(() => import("../pages/CustomFeatures"));
const CustomPlanDetails = lazy(() => import("../pages/CustomPlanDetails"));
const BillingSimulation = lazy(() => import("../pages/BillingSimulation"));
const PlanRequests = lazy(() => import("../pages/PlanRequests"));
const ContactMessages = lazy(() => import("../pages/ContactMessages"));
const Login = lazy(() => import("../pages/Auth/Login"));

const AdminRoutes: React.FC = () => (
  <Routes>
    {/* Default Redirect to Login */}
    <Route path="/" element={<Navigate to={routes.LOGIN} />} />

    {/* Login Route */}
    <Route path={routes.LOGIN} element={<Login />} />

    {/* Forgot password routes */}
    <Route path={routes.CONFIRM_OTP} element={<ConfirmOTP />} />

    <Route path={routes.CREATE_NEW_PASSWORD} element={<CreateNewPassword />} />

    {/* Admin Routes Protected by ProtectedRoute */}
    <Route
      path={routes.ADMIN_DASHBOARD}
      element={
        <ProtectedRoute>
          <AdminDashboard />
        </ProtectedRoute>
      }
    >
      {/* Redirect to Metrics Dashboard when accessing Admin Dashboard root */}
      <Route index element={<Navigate to={routes.METRICS_DASHBOARD} replace />} />

      {/* Admin Dashboard Child Routes */}
      <Route path={routes.PATIENT_LIST} element={<PatientList />} />
      <Route path={routes.CONSULTANT_LIST} element={<ConsultantList />} />
      <Route path={routes.CONSULTANT_DETAILS} element={<ConsultantDetails />} />
      <Route path={routes.CONSULTATIONS_LIST} element={<ConsultationsList />} />
      <Route path={routes.METRICS_DASHBOARD} element={<MetricsDashboard />} />
      <Route path={routes.PLAN_LIST} element={<PlanList />} />
      <Route path={routes.COUPON_LIST} element={<CouponList />} />
      <Route path={routes.COUNTRY_LIST} element={<CountryList />} />
      <Route path={routes.SUBSCRIPTIONS} element={<Subscriptions />} />
      <Route path={routes.SUBSCRIPTION_DETAILS_PATH} element={<SubscriptionDetails />} />
      <Route
        path={routes.SUBSCRIPTION_CUSTOM_FEATURES_PATH}
        element={<CustomFeatures />}
      />
      <Route
        path={routes.SUBSCRIPTION_CUSTOM_PLAN_PATH}
        element={<CustomPlanDetails />}
      />
      <Route path={routes.PLAN_CREATE} element={<PlanBuilder />} />
      <Route path={routes.PLAN_EDIT_PATH} element={<PlanBuilder />} />
      <Route path={routes.PLAN_REQUESTS} element={<PlanRequests />} />
      <Route path={routes.BILLING_SIMULATION} element={<BillingSimulation />} />
      <Route path={routes.CONTACT_MESSAGES} element={<ContactMessages />} />
    </Route>

    {/* 404 Route */}
    <Route path="*" element={<h1>404 - Page Not Found</h1>} />
  </Routes>
);

export default AdminRoutes;
